import { render, staticRenderFns } from "./sysStudent.vue?vue&type=template&id=d80e3872&"
import script from "./sysStudent.vue?vue&type=script&lang=js&"
export * from "./sysStudent.vue?vue&type=script&lang=js&"
import style0 from "./sysStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports